var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.nfts.length)?_c('div',[_c('h2',{staticClass:"title is-2"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),(_setup.showCarousel)?_c(_setup.CarouselList,{attrs:{"nfts":_vm.nfts,"gallery-item-carousel":_vm.galleryItemCarousel,"step":_setup.steps}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }